// src/hooks/usePresence.js
import { useEffect } from 'react';
import { ref, onValue, onDisconnect, set, serverTimestamp } from 'firebase/database';
import { rtdb, auth } from '../firebase';

const usePresence = () => {
  useEffect(() => {
    // Wait for auth to be ready
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (!user) return;

      // Reference to this user's presence node
      const userStatusRef = ref(rtdb, `presence/${user.uid}`);
      
      // Reference to the special '.info/connected' path
      const connectedRef = ref(rtdb, '.info/connected');

      const unsubscribeConnection = onValue(connectedRef, (snapshot) => {
        if (snapshot.val() === false) {
          return;
        }

        // When user disconnects, update their status
        onDisconnect(userStatusRef).set({
          online: false,
          lastSeen: serverTimestamp(),
          email: user.email || 'anonymous'
        }).then(() => {
          // Set user as online
          set(userStatusRef, {
            online: true,
            lastSeen: serverTimestamp(),
            email: user.email || 'anonymous'
          });
        });
      });

      return () => unsubscribeConnection();
    });

    return () => unsubscribeAuth();
  }, []);
};

export default usePresence;